import React from 'react';

const EmbeddedDashboardAuthWrapper = React.lazy(
  () =>
    import(
      '@/features/customer-facing-dashboards/components/CustomerFacingDashboard/EmbeddedDashboardAuthWrapper'
    ),
);

export default {
  path: '/embedded/dashboard/:dashboardId',
  element: <EmbeddedDashboardAuthWrapper />,
};
